import {
  CLEAR_SELECTED_DOMAIN,
  GET_SELECTED_DOMAIN,
  SET_SELECTED_DOMAIN,
  SET_EVENT_STATE,
  SET_EVENT_Credit_Usage,
  SET_EVENT_TIMEZONE,
} from "./SelectedDomainTypes";

const initialState = {
  businessDomainId: "",
  eventState: {},
  smsCredits: {},
  eventTimeZone: {},
};

const SelectedDomainReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SELECTED_DOMAIN:
      return {
        ...state,
      };
    case SET_SELECTED_DOMAIN:
      return {
        ...state,
        businessDomainId: action.payload,
      };
    case SET_EVENT_STATE:
      return {
        ...state,
        eventState: action.payload,
      };
    case SET_EVENT_Credit_Usage:
      return {
        ...state,
        smsCredits: action.payload,
      };
    case SET_EVENT_TIMEZONE:
      return {
        ...state,
        eventTimeZone: action.payload,
      };
    case CLEAR_SELECTED_DOMAIN:
      return {
        ...state,
        businessDomainId: null,
      };
    default:
      return state;
  }
};

export default SelectedDomainReducer;
